/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { TextField } from "@mui/material";

interface ICustomInputTextFieldProps {
  label: string;
  type: string;
  inputProps: any;
  value: string | number;
  onChange: (e: any) => void;
  error: any;
  helperText: any;
  fullWidth: boolean;
  margin: string;
  required: boolean;
  placeholder?: string;
}

export default function CustomInputTextField({ label, type, inputProps, value, onChange, error, helperText, placeholder }: ICustomInputTextFieldProps) {
  // Safely access error and helperText, handling undefined/null cases
  const isError = error && typeof error === 'object' ? !!error[label] : !!error;
  const displayHelperText = helperText && typeof helperText === 'object' ? helperText[label] : helperText;

  if (type === 'number') {
    return (
      <TextField
        label={label}
        type="number"
        inputProps={inputProps}
        value={String(value).length > 0 ? String(value) : ''}
        onChange={onChange}
        error={isError}
        helperText={displayHelperText}
        fullWidth
        margin="dense"
        required
        placeholder={placeholder}
      />
    )
  }

  return (
    <TextField
      label={label}
      type={type}
      value={value}
      onChange={onChange}
      error={isError}
      helperText={displayHelperText}
      fullWidth
      margin="dense"
      required
      placeholder={placeholder}
    />
  )
}

